import CryptoService from './crypto';
import store from '../store';
import router from '../router';
export default class ApiService {
    headers = {
        'Accept': 'application/json',
        'Connection': 'keep-alive',
        'Content-Type': 'application/json'
    };
    constructor() {
        this.apiKey = process.env.VUE_APP_APIKEY;
        this.key = process.env.VUE_APP_KEY;
        this.url = process.env.VUE_APP_ENDPOINT;
        this.cryptojs = new CryptoService();
    }

    post(endpoint, data, auth, nobody) {
        if(auth) {
            this.headers['Authorization'] = store.state.token;
        }
        const dataString = JSON.stringify(data);
        const req = {payload: this.cryptojs.encryptAES(dataString, this.key)};
        return new Promise ((resolve, reject) => {
            fetch(`${this.url}${endpoint}?apiKey=${this.apiKey}`, {
                method: 'post',
                headers: this.headers,
                mode: 'cors',
                cache: 'no-cache',
                body: JSON.stringify(req)
            }).then(res => {
                if (!res.ok) {
                    this.findError(res);
                    reject(res);
                }
                if(nobody) {
                    resolve(res);
                } else {
                    return res.json();
                }
            }).then((res) => {   
                if(auth) {
                    resolve(this.cryptojs.decryptAES(res.payload, this.key));
                } else {
                    resolve(res);
                }
            }).catch((err) => {
                reject(err);
            });
        });
    }

    get(endpoint, auth) {
        if(auth) {
            this.headers['Authorizarion'] = store.state.token;
        }
        fetch(`${this.url}${endpoint}?apiKey=${this.apiKey}`, {
            method: 'get',
            headers: this.headers
        }).then((res) => {
            if (!res.ok) throw Error(res.status);
        }).catch((err) => {
            console.log(err)
        });
    }

    findError(res) {
        if(res.status === 401 || res.status === 403) {
            store.dispatch('setToken', null);
            store.dispatch('setUser', null);
            store.dispatch("setAlert", {
                show: true,
                msg: 'La sesión se venció',
                color: 'error'
            });
            router.push('/');
        }
        if(res.status === 500) {
            store.dispatch("setAlert", {
                show: true,
                msg: 'Error de servidor, contactaté con el equipo dev',
                color: 'error'
            });
        }
    }
}